import { gql, TypedDocumentNode } from "@apollo/client";

import {
  TemplateDeployment,
  Template,
  TemplateTemplateVersionArgs,
  TemplateSearchTemplateVersionsSuggestionsArgs,
  MutationTemplateDeploymentDeleteArgs,
  SearchTemplateDeploymentsOutput,
  SearchInput,
} from "types/generated";

type SearchTemplateDeploymentsData = {
  searchTemplateDeployments: SearchTemplateDeploymentsOutput;
};

type SearchTemplateDeploymentsVariables = {
  input: SearchInput;
};

export const SEARCH_TEMPLATE_DEPLOYMENTS: TypedDocumentNode<
  SearchTemplateDeploymentsData,
  SearchTemplateDeploymentsVariables
> = gql`
  query SearchTemplateDeployments($input: SearchInput!) {
    searchTemplateDeployments(input: $input) {
      edges {
        node {
          id
          allowedActions
          createdAt
          name
          description
          state
          deploymentType
          templateVersion {
            id
            version
          }
          inputs {
            id
            value
          }
        }
        cursor
      }
      pageInfo {
        endCursor
        startCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;

type SearchTemplateVersionsSuggestionsData = {
  template: Template;
};

export const SEARCH_TEMPLATE_VERSIONS_SUGGESTIONS: TypedDocumentNode<
  SearchTemplateVersionsSuggestionsData,
  TemplateTemplateVersionArgs & TemplateSearchTemplateVersionsSuggestionsArgs
> = gql`
  query SearchTemplateVersionsSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    template(id: $id) {
      id
      searchTemplateVersionsSuggestions(input: $input) {
        filteredCount
        fields {
          name
          orderable
          filterable
          type
          possibleValuesBoolean {
            values
            counts
          }
          possibleValuesEnum {
            values
            counts
          }
          possibleValuesString {
            values
            counts
          }
          possibleValuesHierarchy {
            values {
              id
              parentId
              displayValue
            }
            counts
          }
        }
      }
    }
  }
`;

type DeleteTemplateDeploymentData = {
  templateDeploymentDelete: Pick<TemplateDeployment, "id" | "name">;
};

export const DELETE_DEPLOYMENT: TypedDocumentNode<
  DeleteTemplateDeploymentData,
  MutationTemplateDeploymentDeleteArgs
> = gql`
  mutation TemplateDeploymentDelete($templateID: ID!, $id: ID!, $skipStackDeletion: Boolean!) {
    templateDeploymentDelete(
      templateID: $templateID
      id: $id
      skipStackDeletion: $skipStackDeletion
    ) {
      id
      name
    }
  }
`;
